/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_161Inputs */

const cs_ares_legal_form_161 = /** @type {(inputs: Ares_Legal_Form_161Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příspěvková organizace`)
};

const en_ares_legal_form_161 = /** @type {(inputs: Ares_Legal_Form_161Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allowance organization`)
};

/**
* | output |
* | --- |
* | "Allowance organization" |
*
* @param {Ares_Legal_Form_161Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_161 = /** @type {((inputs?: Ares_Legal_Form_161Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_161Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_161(inputs)
	return cs_ares_legal_form_161(inputs)
});